import './main.less';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import { enum as permissions } from '../../../../../enums/admin-permissions';

const navigation = [
	{
		href: '/banners/publications',
		name: 'Publications',
		permission: null
	},
	{
		href: '/banners/contents',
		name: 'Contents',
		permission: null
	},
	{
		href: '/banners/custom-content',
		name: 'Custom content',
		permission: null
	},
	{
		href: '/banners/images',
		name: 'Images',
		permission: null
	},
	{
		href: '/banners/campaigns',
		name: 'Campaigns',
		permission: null
	},
	{
		href: '/banners/manual',
		name: 'Manual',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'Banners',
	tabs: navigation,
	permission: permissions.banners
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/wrap-main.js